import React, { useEffect, useState } from 'react'
import { generateQuarterlyReport, getQuarterlyReport } from '../services/api';
import { SmallButton } from '../styles/Buttons';
import GenerateReport from '../components/GenerateReport';

const QuarterlyReport = () => {
  const config = [
    {
      key: 'standardsPublish',
      apiKey: 'standards_publish',
      type: 'publish',
      title: 'Fastställda standarder',
      moduleId: 'standards-publish',
    },
    {
      key: 'standardsAnnulment',
      apiKey: 'standards_annulment',
      type: 'annulment',
      title: 'Upphävda standarder',
      moduleId: 'standards-annulment'
    },
    {
      key: 'alteredPublForm',
      apiKey: 'altered_publ_form',
      type: 'publish',
      title: 'Ändrad publiceringsform, tidigare ikraftsatt genom offentliggörande',
      moduleId: 'altered-publ-form',
      isEditable: true,
    },
    {
      key: 'addedValue',
      apiKey: 'added_value',
      type: 'publish',
      title: 'Mervärdesprodukter',
      moduleId: 'added-value'
    },
    {
      key: 'trPublish',
      apiKey: 'TR_publish',
      type: 'publish',
      title: 'Publicerade SEK Tekniska Rapporter',
      moduleId: 'TR-publish'
    },
    {
      key: 'tsPublish',
      apiKey: 'TS_publish',
      type: 'publish',
      title: 'Publicerade SEK Tekniska Specifikationer',
      moduleId: 'TS-publish'
    },
    {
      key: 'iecAsSekPubl',
      apiKey: 'iec_as_sek_publ',
      type: 'publish',
      title: 'IEC-publikationer fastställda som SEK-publikationer',
      moduleId: 'iec-as-sek-publ'
    },
    {
      key: 'iecAsSekTr',
      apiKey: 'iec_as_sek_tr',
      type: 'publish',
      title: 'IEC-publikationer fastställda som SEK Tekniska Rapporter',
      moduleId: 'iec-as-sek-tr'
    },
    {
      key: 'handbooks',
      apiKey: 'handbooks',
      type: 'publish',
      title: 'Handböcker',
      moduleId: 'handbooks'
    },
    {
      key: 'tekniklitteratur',
      apiKey: 'tekniklitteratur',
      type: 'publish',
      title: 'Tekniklitteratur',
      moduleId: 'tekniklitteratur'
    },

  ];

  return (
    <GenerateReport
      type='quarterlyReport'
      title='sammanställning (kvartal)'
      name='Sammanställning av fastställda och upphävda standarder per korrespondens'
      initialItems={{
        standardsPublish: [],
        standardsAnnulment: [],
        alteredPublForm: [],
        addedValue: [],
        trPublish: [],
        tsPublish: [],
        iecAsSekPubl: [],
        iecAsSekTr: [],
        handbooks: [],
        tekniklitteratur: [],
      }}
      dateStorageKeys={{
        year: 'year',
        startMonth: 'start_month',
        endMonth: 'end_month'
      }}
      config={config}
      fetchReport={({ year, startMonth, endMonth }) =>
        getQuarterlyReport(startMonth, endMonth, year)
      }
      generateReport={(dates, report) => {
        const payload = {
          ...report,
          alteredPublForm: report.alteredPublForm.map((item) => ({
            ...item,
            comment: item.comment?.trim() || ''
          }))
        };
        return generateQuarterlyReport(dates, payload)
      }}
    />
  )
}

export default QuarterlyReport